<template>
    <div class="apply-page-container"></div>
</template>

<script>
// import userService from '@/services/user'
// import { sendMetaTransition } from '@/services/meta-event'

export default {
    name: 'SpecialOfferPage',
    components: {},
    data: () => ({
        version: 0,
    }),
}
</script>

<style lang="scss" scoped></style>
